import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { createRegolaSpedizione, updateRegolaSpedizione } from '../services/api';

const RegolaSpedizioneModal = ({ show, handleClose, regola, corriereId }) => {
  const isEditMode = !!regola;
  const initialFormData = useMemo(() => ({
    nome_regola: '',
    canale: 'SITO_WEB',
    codice_logica: 'STANDARD_ITA',
    costo: 0.0,
    corriere_id: corriereId,
  }), [corriereId]);

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (isEditMode) {
      setFormData({
        nome_regola: regola.nome_regola || '',
        canale: regola.canale || 'SITO_WEB',
        codice_logica: regola.codice_logica || 'STANDARD_ITA',
        costo: regola.costo || 0.0,
        corriere_id: regola.corriere_id,
      });
    } else {
      setFormData({ ...initialFormData, corriere_id: corriereId });
    }
  }, [regola, corriereId, isEditMode, initialFormData]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let processedValue = value;
    
    if (type === 'number') {
      // Se il campo è vuoto, mantieni stringa vuota per permettere la cancellazione
      // Altrimenti converti in numero, usando 0 se il risultato è NaN
      if (value === '') {
        processedValue = '';
      } else {
        const numValue = parseFloat(value);
        processedValue = isNaN(numValue) ? 0 : numValue;
      }
    }
    
    setFormData({ ...formData, [name]: processedValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Assicurati che il costo sia un numero valido prima dell'invio
      const dataToSubmit = {
        ...formData,
        costo: typeof formData.costo === 'string' && formData.costo === '' ? 0 : parseFloat(formData.costo) || 0
      };
      
      if (isEditMode) {
        await updateRegolaSpedizione(regola.id, dataToSubmit);
        alert('Regola aggiornata con successo!');
      } else {
        await createRegolaSpedizione(dataToSubmit);
        alert('Regola creata con successo!');
      }
      handleClose();
    } catch (error) {
      console.error('Errore durante il salvataggio della regola:', error);
      alert('Errore durante il salvataggio.');
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{isEditMode ? 'Modifica Regola' : 'Nuova Regola'} di Spedizione</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formNomeRegola">
            <Form.Label>Nome Regola</Form.Label>
            <Form.Control
              type="text"
              name="nome_regola"
              value={formData.nome_regola}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formCanale">
                <Form.Label>Canale</Form.Label>
                <Form.Select name="canale" value={formData.canale} onChange={handleChange}>
                  <option value="SITO_WEB">SITO WEB</option>
                  <option value="IBS">IBS</option>
                  <option value="NEGOZIO">NEGOZIO</option>
                  <option value="FELTRINELLI">FELTRINELLI</option>
                  <option value="RIVERSAMENTI">RIVERSAMENTI</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group className="mb-3" controlId="formCodiceLogica">
                    <Form.Label>Logica di Spedizione</Form.Label>
                    <Form.Select name="codice_logica" value={formData.codice_logica} onChange={handleChange}>
                        <optgroup label="Italia">
                            <option value="MODENA">Modena (ritiro in negozio)</option>
                            <option value="STANDARD_ITA">Standard Italia</option>
                            <option value="ISOLE_SUD">Isole e Sud Italia</option>
                        </optgroup>
                        
                        <optgroup label="Paesi UE - Centrale">
                            <option value="FRANCIA">Francia</option>
                            <option value="GERMANIA">Germania</option>
                            <option value="AUSTRIA">Austria</option>
                            <option value="BELGIO">Belgio</option>
                            <option value="PAESI_BASSI">Paesi Bassi</option>
                            <option value="LUSSEMBURGO">Lussemburgo</option>
                        </optgroup>
                        
                        <optgroup label="Paesi UE - Sud">
                            <option value="SPAGNA">Spagna</option>
                            <option value="PORTOGALLO">Portogallo</option>
                            <option value="GRECIA">Grecia</option>
                            <option value="MALTA">Malta</option>
                            <option value="CIPRO">Cipro</option>
                        </optgroup>
                        
                        <optgroup label="Paesi UE - Est">
                            <option value="POLONIA">Polonia</option>
                            <option value="REPUBBLICA_CECA">Repubblica Ceca</option>
                            <option value="UNGHERIA">Ungheria</option>
                            <option value="ROMANIA">Romania</option>
                            <option value="BULGARIA">Bulgaria</option>
                            <option value="CROAZIA">Croazia</option>
                            <option value="SLOVACCHIA">Slovacchia</option>
                            <option value="SLOVENIA">Slovenia</option>
                        </optgroup>
                        
                        <optgroup label="Paesi UE - Nord">
                            <option value="DANIMARCA">Danimarca</option>
                            <option value="SVEZIA">Svezia</option>
                            <option value="FINLANDIA">Finlandia</option>
                            <option value="IRLANDA">Irlanda</option>
                            <option value="ESTONIA">Estonia</option>
                            <option value="LETTONIA">Lettonia</option>
                            <option value="LITUANIA">Lituania</option>
                        </optgroup>
                        
                        <optgroup label="Altri Paesi Europa">
                            <option value="SVIZZERA">Svizzera</option>
                            <option value="NORVEGIA">Norvegia</option>
                            <option value="ISLANDA">Islanda</option>
                        </optgroup>
                        
                        <optgroup label="Generici">
                            <option value="UE">UE (generico)</option>
                            <option value="EXTRA_UE">Extra UE</option>
                        </optgroup>
                    </Form.Select>
                </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3" controlId="formCosto">
            <Form.Label>Costo</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="costo"
              value={formData.costo}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annulla
          </Button>
          <Button variant="primary" type="submit">
            Salva Regola
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default RegolaSpedizioneModal;
